import { render, staticRenderFns } from "./DepartureElement.vue?vue&type=template&id=b05829aa&scoped=true&"
import script from "./DepartureElement.vue?vue&type=script&lang=js&"
export * from "./DepartureElement.vue?vue&type=script&lang=js&"
import style0 from "./DepartureElement.vue?vue&type=style&index=0&id=b05829aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05829aa",
  null
  
)

export default component.exports